import {Roles} from "../configs/roles/ProjectRole";
import {Contacts, Person, ShoppingBasket} from "@material-ui/icons";
import {Sliders} from "react-feather";
import {MdOutlineLibraryBooks, MdWork} from "react-icons/md";
import {RiArticleLine, RiDashboardLine} from "react-icons/ri";
import {FaHandshake, FaQuestion} from "react-icons/fa";
import {TbCameraPlus} from "react-icons/tb";
import {TfiGallery} from "react-icons/tfi";
import {Icon} from "@mui/material";

const sidebarItems = [
    //admin
    {
        id: 'admin/dashboard',
        title: 'داشبورد',
        icon: <RiDashboardLine/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/dashboard'
    },
    {
        id: "admin/menu-management",
        title: "منو",
        icon: <MdOutlineLibraryBooks/>,
        navLink: '/panel/admin/menu-management',
        roles: [Roles.admin],
        permissions: []
    },
    {
        id: 'admin/articles-categories',
        title: 'دسته بندی مقالات',
        icon: <MdOutlineLibraryBooks/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/articles-categories'
    },
    {
        id: 'admin/articles',
        title: 'مقالات',
        icon: <RiArticleLine/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/articles'
    },
/*    {
        id: 'admin/products-categories',
        title: 'دسته بندی محصولات',
        icon: <ShoppingBasket size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/products-categories'
    },
    {
        id: 'admin/products',
        title: 'Products',
        icon: <ShoppingBasket size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/products'
    },*/
    {
        id: 'Stories',
        title: 'Stories',
        icon: <TbCameraPlus size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/Stories'
    },
    {
        id: 'admin/services-category',
        title: 'دسته بندی خدمات',
        icon: <ShoppingBasket size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/services-category'
    },
    {
        id: 'admin/services',
        title: 'Services',
        icon: <ShoppingBasket size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/services'
    },
    {
        id: 'gallery',
        title: 'Gallery',
        icon: <TfiGallery size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/gallery'
    },
/*    {
        id: 'sliders',
        title: 'sliders',
        icon: <Sliders size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/sliders'
    },*/
    {
        id: 'faq',
        title: 'FAQ',
        icon: <FaQuestion size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/faq'
    },
    {
        id: 'Personnel',
        title: 'پرسنل',
        icon: <Person size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/Personnel'
    },
    {
        id: 'Activity',
        title: 'فعالیت ها',
        icon: <Person size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/Activity'
    },
    {
        id: 'contactus',
        title: 'ContactUs',
        icon: <Contacts size={20}/>,
        roles: [Roles.admin],
        permissions: [],
        navLink: '/panel/admin/contactus'
    },

   {
        id: 'admin/collaboration-requests',
        title: 'درخواست های همکاری',
        icon: <FaHandshake/>,
        navLink: '/panel/admin/collaboration-requests'
    },
 /*    {
        id: 'admin/employment-requests',
        title: 'درخواست های استخدام',
        icon: <MdWork/>,
        navLink: '/panel/admin/employment-requests'
    }*/
]

export default sidebarItems;
